import React, {Component} from 'react';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn
} from 'material-ui/Table';
import CardType from '../../../enums/CardType';
import T from 'i18n-react';
import SortComponent from '../../sort/SortComponent';
import {sortAlphabetically} from '../../../utils/OrderUtils';
import '../TableStripped.css';
import FilterType from '../../../enums/FilterType';
import ColorEnum from '../../../enums/ColorEnum';
import OperationTypeEnum from '../../../enums/OperationTypeEnum';
import OPERATION_CATEGORY from '../../../enums/OperationCategoryEnum';
import OperationService from "../../../services/OperationService";
import STREAM_TYPE from '../../../enums/StreamType';

/**
 * Tableau permettant d'afficher les informations CODA & N43
 * Prend en paramètre : Date format "jj-mm-aaaa"
 */
class TableStrippedPeriodic extends Component {

    constructor(props) {
        super(props);
        this.state = {
            location: props.location,
            operationList: props.operationList,
            openInvoiceDialog: false,
            invoiceDownloadOperationId: '',
            invoiceDownloadContractNumber: '',
            invoiceError: false,
            invoiceAlreadyDeleted: false,
            detailsDateTransaction: props.detailsDateTransaction
        };
        this.tableRowList = [];
        this.headerItemList = [];
        this.tableRowIndex = -1;
    }

    /**
     * Quand on récupère de nouvelle props on refait l'appel WS
     * @param {*} newProps
     */
    componentWillReceiveProps(newProps) {
        this.setState({'operationList': newProps.operationList, 'location': newProps.location});
    }

    renderCreditCard(cardType) {
        if (CardType[cardType]) {
            return (
                <div>
                    <img src={`${process.env.PUBLIC_URL}/${CardType[cardType].img}`} alt="credit card logo"/>
                    <span className="creditCardName">{T.translate(CardType[cardType].name)}</span>
                </div>
            );
        }
        return;
    }

    render() {
        this.createHeaderItems();
        if (this.state.operationList) {
            this.setTableRowList();
            return (
                    <Table className="tableStripped"
                           fixedHeader={true}
                           fixedFooter={true}>
                        {this.getTableHeader()}
                        <TableBody
                            displayRowCheckbox={false}
                            stripedRows={true}>
                            {this.tableRowList}
                        </TableBody>
                    </Table>
            );
        } else { // Si on n'a 0 données on affiche un message
            return (
                <div>{T.translate("table.empty")}</div>
            );
        }
    }

    getStrippedStyle(index) {
        return {'backgroundColor': index % 2 ? ColorEnum.WHITE : '#eeeeee'};
    }

    getStrippedStyleFundingDate(index) {
        return {
            'backgroundColor': index % 2 ? ColorEnum.WHITE : '#eeeeee',
            'borderTop': index % 2 ? '1px solid' + ColorEnum.WHITE : '1px solid #eeeeee'
        };
    }

    /**********************************************
     * ********* Contruction du tableau ***********
     **********************************************/

    /**
     *  Création du body du tableau
     */
    setTableRowList() {
        this.tableRowList = [];
        this.tableRowIndex = -1;
        for (let i = 0; i < this.state.operationList.operationPeriodicList.length; i++) {
            //On crée une ligne par operation
            this.createTableRowOperation(i);

            //On ajoute les lignes pour les sous totaux si c'est le détail par date de transaction
            if(this.state.detailsDateTransaction) {
                if (this.state.operationList.operationPeriodicList[i].hasRegular && (this.state.operationList.operationPeriodicList[i].hasProcessingFees || this.state.operationList.operationPeriodicList[i].hasUnpaidFr)) {
                    this.tableRowList.push(this.getRegularSubtotalRow(this.state.operationList.operationPeriodicList[i]))
                }
                if (this.state.operationList.operationPeriodicList[i].hasProcessingFees) {
                    this.tableRowList.push(this.getProcessingFeesRow(this.state.operationList.operationPeriodicList[i]));
                }
                if (this.state.operationList.operationPeriodicList[i].hasUnpaidFr) {
                    this.tableRowList.push(this.getUnpaidFrSubtotalRow(this.state.operationList.operationPeriodicList[i]));
                }
                if (this.state.operationList.operationPeriodicList[i].hasProcessingFees || this.state.operationList.operationPeriodicList[i].hasUnpaidFr) {
                    this.tableRowList.push(this.getNetBankingRow(this.state.operationList.operationPeriodicList[i]));
                } else {
                    this.tableRowList.push(this.getNetCommonSubTotal(this.state.operationList.operationPeriodicList[i]));
                }
            }
        }
    }

    /**
     * Récupère la sous liste des opération par date de financement
     * @param index
     * @return {Array}
     */
    createTableRowOperation(parentIndex) {
        const fundingDate = this.state.operationList.operationPeriodicList[parentIndex].fundingDate;
        const indexFundingDateRow = this.tableRowIndex + 1;

        if (this.state.location !== 'FR') {
            this.tableRowList.push(this.state.operationList.operationPeriodicList[parentIndex].operationList.map((data, index) => {
                    this.tableRowIndex++;
                    return <TableRow key={this.tableRowIndex}>
                        <TableRowColumn className="tableRowWeight fundindDateCellPeriodic"
                                        style={index === 0 ? this.getStrippedStyle(this.tableRowIndex) : this.getStrippedStyleFundingDate(indexFundingDateRow)}>
                            {index === 0 ? fundingDate !== null ? fundingDate : '-' : ''}
                        </TableRowColumn>
                        <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)} className="tooltip tinyColumn">
                            {data.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                <div className="actionButton" onClick={() => {this.props.handleInvoiceDownload(data.idInvoice)}}>
                                    {data.contractNumber}
                                </div>
                                :
                                <div className="">{data.contractNumber}</div>
                            }
                        </TableRowColumn>
                        <TableRowColumn className="tooltip" style={this.getStrippedStyle(this.tableRowIndex)}>
                            <div className=""> {data.nameShop} </div>
                            <span className="hooverText"> {data.nameShop} </span>
                        </TableRowColumn>
                        <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                            {data.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                ''
                                :
                                data.tradeDate !== null ? data.tradeDate : '-'}
                        </TableRowColumn>
                        <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                            {this.state.location === 'BE' ? this.renderCreditCard(data.cardType) : ''}
                            {this.state.location === 'ES' && data.operationType && data.sens ? OperationTypeEnum[data.operationType.toString() + data.sens.toString()] : ''}
                        </TableRowColumn>
                        <TableRowColumn className="tooltip" style={this.getStrippedStyle(this.tableRowIndex)}>
                            {data.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                <div>
                                    <div className=""> {T.translate('table.processingFees')} </div>
                                </div>
                                :
                                data.sens > 0 ? T.translate('table.debit') : T.translate('table.credit')
                            }
                        </TableRowColumn>
                        <TableRowColumn className="alignRight" style={this.getStrippedStyle(this.tableRowIndex)}>
                            {data.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                this.getAmountString(0)
                                :
                                this.getAmountString(data.grossAmount)}
                        </TableRowColumn>
                        <TableRowColumn className="alignRight" style={this.getStrippedStyle(this.tableRowIndex)}>
                            {this.getAmountString(data.netAmount - data.grossAmount)}
                        </TableRowColumn>
                        <TableRowColumn className="alignRight" style={this.getStrippedStyle(this.tableRowIndex)}>
                            {this.getAmountString(data.netAmount)}
                        </TableRowColumn>
                    </TableRow>
                }
                )
            );
        } else {
            this.tableRowList.push(this.state.operationList.operationPeriodicList[parentIndex].operationList.map((data, index) => {
                    this.tableRowIndex++;
                    return <TableRow key={this.tableRowIndex}>
                        <TableRowColumn className="tableRowWeight fundindDateCellPeriodic"
                                        style={index === 0 ? this.getStrippedStyle(this.tableRowIndex) : this.getStrippedStyleFundingDate(indexFundingDateRow)}>
                            {index === 0 ? fundingDate !== null ? fundingDate : '-' : '-'}
                        </TableRowColumn>
                        {
                            this.renderFRContractNumberColumn(data, this.tableRowIndex)
                        }
                        <TableRowColumn className="tooltip" style={this.getStrippedStyle(this.tableRowIndex)}>
                            <div className=""> {data.nameShop} </div>
                            <span className="hooverText"> {data.nameShop} </span>
                        </TableRowColumn>
                        <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                            {data.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                ''
                                :
                                data.tradeDate !== null ? data.tradeDate : '-'}
                        </TableRowColumn>
                        {this.props.selectedStreamType === STREAM_TYPE.PASS_CARD ?
                            null :
                            this.renderOperationActivity(data, this.tableRowIndex)
                        }
                        <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)} className="big-padding-right alignRight">
                            {data.category === OPERATION_CATEGORY.PROCESSING_FEES || data.nbTransactions == null ?
                                ''
                                :
                                data.nbTransactions.toString()}
                        </TableRowColumn>
                        <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)} className="tooltip">
                            {data.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                <div>
                                    <div className=""> {T.translate('table.processingFees')} </div>
                                </div>
                                :
                                data.sens > 0 ? T.translate('table.debit') : T.translate('table.credit')
                            }
                        </TableRowColumn>
                        <TableRowColumn className="alignRight" style={this.getStrippedStyle(this.tableRowIndex)}>
                            {data.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                this.getAmountString(0)
                                :
                                this.getAmountString(data.grossAmount)}
                        </TableRowColumn>
                        <TableRowColumn className="alignRight" style={this.getStrippedStyle(this.tableRowIndex)}>
                            {this.getAmountString(data.netAmount - data.grossAmount)}
                        </TableRowColumn>
                        <TableRowColumn className="alignRight" style={this.getStrippedStyle(this.tableRowIndex)}>
                            {this.getAmountString(data.netAmount)}
                        </TableRowColumn>
                    </TableRow>
                }
                )
            );
        }
    }

    getRegularSubtotalRow(operationList) {
        this.tableRowIndex++;
        return (
            <TableRow key={this.tableRowList} className="tableRowWeight">
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                    {T.translate('table.subTotalRevenues')}
                </TableRowColumn>
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}></TableRowColumn>
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}></TableRowColumn>
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}></TableRowColumn>
                {this.props.selectedStreamType === STREAM_TYPE.PASS_CARD ?
                    null :
                    <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}></TableRowColumn>

                }
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}></TableRowColumn>
                {this.state.location === 'FR' ?
                    <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                    </TableRowColumn>
                    :
                    ''
                }
                <TableRowColumn className="alignRight" style={this.getStrippedStyle(this.tableRowIndex)}>
                    {this.getAmountString(operationList.totalGrossAmount)}
                </TableRowColumn>
                <TableRowColumn className="alignRight" style={this.getStrippedStyle(this.tableRowIndex)}>
                    {this.getAmountString(operationList.totalFee)}
                </TableRowColumn>
                <TableRowColumn className="alignRight" style={this.getStrippedStyle(this.tableRowIndex)}>
                    {this.getAmountString(operationList.totalNetAmount)}
                </TableRowColumn>
            </TableRow>
        );
    }

    getUnpaidFrSubtotalRow(operation) {
        this.tableRowIndex++;
        return (
            <TableRow key={this.tableRowList} className="tableRowWeight">
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                    {T.translate('table.subTotalUnpaid')}
                </TableRowColumn>
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}></TableRowColumn>
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}></TableRowColumn>
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}></TableRowColumn>
                {this.props.selectedStreamType === STREAM_TYPE.PASS_CARD ?
                    null :
                    <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}></TableRowColumn>

                }
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}></TableRowColumn>
                {this.state.location === 'FR' ?
                    <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                    </TableRowColumn>
                    :
                    ''
                }
                <TableRowColumn className="alignRight" style={this.getStrippedStyle(this.tableRowIndex)}>
                    {this.getAmountString(operation.totalGrossUnpaid)}
                </TableRowColumn>
                <TableRowColumn className="alignRight" style={this.getStrippedStyle(this.tableRowIndex)}>
                    {this.getAmountString(operation.totalGrossUnpaid - operation.totalNetUnpaid)}
                </TableRowColumn>
                <TableRowColumn className="alignRight" style={this.getStrippedStyle(this.tableRowIndex)}>
                    {this.getAmountString(operation.totalNetUnpaid)}
                </TableRowColumn>
            </TableRow>
        );
    }

    /**
     * Récupération du sous total de la liste des processing fees (deduction facture)
     * @param operation
     * @return {XML}
     */
    getProcessingFeesRow(operation) {
        this.tableRowIndex++;
        return (
            <TableRow key={this.tableRowList} className="tableRowWeight">
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                    {T.translate('table.subTotalProcessingFeesInvoiceDeduction')}
                </TableRowColumn>
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                </TableRowColumn>
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                </TableRowColumn>
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                </TableRowColumn>
                {this.props.selectedStreamType === STREAM_TYPE.PASS_CARD ?
                    null :
                    <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}></TableRowColumn>

                }
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                </TableRowColumn>
                {this.state.location === 'FR' ?
                    <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                    </TableRowColumn>
                    :
                    ''
                }
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                </TableRowColumn>
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                </TableRowColumn>
                <TableRowColumn className="alignRight" style={this.getStrippedStyle(this.tableRowIndex)}>
                    {this.getAmountString(operation.totalProcessingFees)}
                </TableRowColumn>
            </TableRow>
        );
    }

    /**
     * Récupération du sous total du NET BANCAIRE
     * @param operationList
     * @return {XML}
     */
    getNetBankingRow(operationList) {
        this.tableRowIndex++;
        return (
            <TableRow key={this.tableRowIndex} className="tableRowWeight">
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                    {T.translate("table.subTotalNetBanking")}
                </TableRowColumn>
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                </TableRowColumn>
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                </TableRowColumn>
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                </TableRowColumn>
                {this.props.selectedStreamType === STREAM_TYPE.PASS_CARD ?
                    null :
                    <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}></TableRowColumn>

                }
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                </TableRowColumn>
                {this.state.location === 'FR' ?
                    <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                    </TableRowColumn>
                    :
                    ''
                }
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                </TableRowColumn>
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                </TableRowColumn>
                <TableRowColumn className="alignRight" style={this.getStrippedStyle(this.tableRowIndex)}>
                    {this.getAmountString(operationList.totalNetBanking)}
                </TableRowColumn>
            </TableRow>
        );
    }

    getNetCommonSubTotal(operationList) {
        this.tableRowIndex++;
        return (
            <TableRow key={this.tableRowIndex} className="tableRowWeight">
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                    {T.translate('table.subTotal')}
                </TableRowColumn>
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}></TableRowColumn>
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}></TableRowColumn>
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}></TableRowColumn>
                {this.props.selectedStreamType === STREAM_TYPE.PASS_CARD ?
                    null :
                    <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}></TableRowColumn>

                }
                <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}></TableRowColumn>
                {this.state.location === 'FR' ?
                    <TableRowColumn style={this.getStrippedStyle(this.tableRowIndex)}>
                    </TableRowColumn>
                    :
                    ''
                }
                <TableRowColumn className="alignRight" style={this.getStrippedStyle(this.tableRowIndex)}>
                    {this.getAmountString(operationList.totalGrossAmount)}
                </TableRowColumn>
                <TableRowColumn className="alignRight" style={this.getStrippedStyle(this.tableRowIndex)}>
                    {this.getAmountString(operationList.totalFee)}
                </TableRowColumn>
                <TableRowColumn className="alignRight" style={this.getStrippedStyle(this.tableRowIndex)}>
                    {this.getAmountString(operationList.totalNetAmount)}
                </TableRowColumn>
            </TableRow>
        );
    }

    /**
     * Retourne le footer du tableau
     */
    getTableHeader() {
        let headerRowList = [];

        let hasAllTotalHeaderField = false;

        if (this.state.operationList.hasRegular && (this.state.operationList.hasProcessingFees || this.state.operationList.hasUnpaidFr)) {
            hasAllTotalHeaderField = true;
            headerRowList.push(this.getRowTotalRegular());
            if (this.props.location === 'FR') {
                headerRowList.push(this.getRowTotalProximity());
                headerRowList.push(this.getRowTotalECommerce());
                headerRowList.push(this.getRowTotalPass());
            }
        }
        if (this.state.operationList.hasProcessingFees) {
            headerRowList.push(this.getRowTotalInvoiceDeduction(false));
        }
        if (this.state.operationList.hasUnpaidFr) {
            hasAllTotalHeaderField = true;
            headerRowList.push(this.getRowTotalFrUnpaid());
        }
        // Le total dépend si on a des faris de processing ou pas, a changer plus tard
        if (this.state.operationList.hasProcessingFees || this.state.operationList.hasUnpaidFr) {
            headerRowList.push(this.getRowTotalNetBanking());
        } else {
            hasAllTotalHeaderField = true;
            headerRowList.push(this.getRowDebitCreditCommon(null));
            if (this.props.location === 'FR') {
                headerRowList.push(this.getRowTotalProximity());
                headerRowList.push(this.getRowTotalECommerce());
                headerRowList.push(this.getRowTotalPass());
            } else {
                headerRowList.push(this.getRowDebitCreditCommon(false));
                headerRowList.push(this.getRowDebitCreditCommon(true));
            }
        }

        headerRowList.push(this.getTableHeaderFields());

        headerRowList.unshift(this.getTableTotalHeaderFields(hasAllTotalHeaderField));

        return (
            <TableHeader className="headerTableStripped" displaySelectAll={false} adjustForCheckbox={false}>
                {headerRowList}
            </TableHeader>
        )
    }

    getRowTotalRegular() {
        return (
            <TableRow key={'footer-regular'} className="important">
                <TableRowColumn colSpan={this.getSpanColumn() - 1}>{T.translate("table.totalRevenues")}</TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.props.location === 'FR' ? this.state.operationList.totalNbTransactions : null}
                </TableRowColumn>
                <TableRowColumn className="tinyColumn" />
                <TableRowColumn
                    className="alignRight">{this.getAmountString(this.state.operationList.totalGrossAmount)}</TableRowColumn>
                <TableRowColumn
                    className="alignRight">{this.getAmountString(this.state.operationList.totalFee)}</TableRowColumn>
                <TableRowColumn
                    className="alignRight">{this.getAmountString(this.state.operationList.totalNetAmount)}</TableRowColumn>
            </TableRow>
        );
    }

    getRowTotalFrUnpaid() {
        return (
            <TableRow key={'footer-unpaid-fra'} className="important">
                <TableRowColumn colSpan={this.getSpanColumn() - 1}>{T.translate("table.unpaidTotal")}</TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.props.location === 'FR' ? this.state.operationList.totalNbTransactionsUnpaid : null}
                </TableRowColumn>
                <TableRowColumn className="tinyColumn" />
                <TableRowColumn
                    className="alignRight">{this.getAmountString(this.state.operationList.totalGrossUnpaid)}</TableRowColumn>
                <TableRowColumn
                    className="alignRight">{this.getAmountString(this.state.operationList.totalGrossUnpaid - this.state.operationList.totalNetUnpaid)}</TableRowColumn>
                <TableRowColumn
                    className="alignRight">{this.getAmountString(this.state.operationList.totalNetUnpaid)}</TableRowColumn>
            </TableRow>
        );
    }
    /**
     * Permet de créer une ligne de total pour les crédits ou les débit, ou la somme des 2 suivant le paramètre en entré
     * null -> Crédit + Débit
     * true -> Débit
     * false -> Crédit
     * @param negativeSens
     * @returns {JSX.Element}
     */
    getRowDebitCreditCommon(negativeSens) {
        return (
            <TableRow key={'header-common-total'} className={negativeSens === null ? 'important' : ''}>
                <TableRowColumn colSpan={this.getSpanColumn() - 1}>
                    {
                        negativeSens === null ? T.translate('table.total') :
                            negativeSens ? T.translate('table.debitTotal') : T.translate('table.creditTotal')
                    }
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.props.location === 'FR' ?
                        (negativeSens === null ? this.state.operationList.totalNbTransactions :
                            negativeSens > 0 ? this.state.operationList.totalNbTransactionsDebit :
                                this.state.operationList.totalNbTransactionsCredit) : null}
                </TableRowColumn>
                <TableRowColumn className="tinyColumn" />
                <TableRowColumn className="alignRight">
                    {negativeSens === null ? this.getAmountString(this.state.operationList.totalGrossAmount) :
                        negativeSens > 0 ? this.getAmountString(this.state.operationList.totalGrossAmountDebit) :
                            this.getAmountString(this.state.operationList.totalGrossAmountCredit)}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {negativeSens === null ? this.getAmountString(this.state.operationList.totalFee) :
                        negativeSens > 0 ? this.getAmountString(this.state.operationList.totalFeeDebit) :
                            this.getAmountString(this.state.operationList.totalFeeCredit)}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {negativeSens === null ? this.getAmountString(this.state.operationList.totalNetAmount) :
                        negativeSens > 0 ? this.getAmountString(this.state.operationList.totalNetAmountDebit) :
                            this.getAmountString(this.state.operationList.totalNetAmountCredit)}
                </TableRowColumn>
            </TableRow>
        );
    }

    getRowTotalProximity() {
        return (
            <TableRow key='header-proximity-total'>
                <TableRowColumn colSpan={this.getSpanColumn() - 1}>
                    {T.translate('table.proximity')}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.props.location === 'FR' ? this.state.operationList.proximityTotalNbTransactions : null}
                </TableRowColumn>
                <TableRowColumn className="tinyColumn" />
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.state.operationList.proximityTotalGrossAmount)}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.state.operationList.proximityTotalFee)}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.state.operationList.proximityTotalNetAmount)}
                </TableRowColumn>
            </TableRow>
        );
    }

    getRowTotalECommerce() {
        return (
            <TableRow key='header-ecommerce-total'>
                <TableRowColumn colSpan={this.getSpanColumn() - 1}>
                    {T.translate('table.eCommerce')}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.props.location === 'FR' ? this.state.operationList.eCommerceTotalNbTransactions : null}
                </TableRowColumn>
                <TableRowColumn className="tinyColumn" />
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.state.operationList.eCommerceTotalGrossAmount)}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.state.operationList.eCommerceTotalFee)}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.state.operationList.eCommerceTotalNetAmount)}
                </TableRowColumn>
            </TableRow>
        );
    }

    getRowTotalPass() {
        return (
            <TableRow key='header-pass-total'>
                <TableRowColumn colSpan={this.getSpanColumn() - 1}>
                    {T.translate('table.pass')}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.props.location === 'FR' ? this.state.operationList.passTotalNbTransactions : null}
                </TableRowColumn>
                <TableRowColumn className="tinyColumn" />
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.state.operationList.passTotalGrossAmount)}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.state.operationList.passTotalFee)}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.state.operationList.passTotalNetAmount)}
                </TableRowColumn>
            </TableRow>
        );
    }

    getSpanColumn() {
        return this.headerItemList.filter(value => !!value).length - 4;
    }

    getRowTotalInvoiceDeduction() {
        if (this.state.operationList.hasProcessingFees) {
            return (
                <TableRow key={'footer-processign-fees'}>
                    <TableRowColumn
                        colSpan={this.getSpanColumn() + 3}>{T.translate('table.processingFeesInvoiceDeduction')}</TableRowColumn>
                    <TableRowColumn
                        className="alignRight">{this.getAmountString(this.state.operationList.totalProcessingFees)}</TableRowColumn>
                </TableRow>
            );
        }
    }

    getRowTotalNetBanking() {
        return (
            <TableRow key={'footer-total-net-banking'} className="important">
                <TableRowColumn
                    colSpan={this.getSpanColumn() + 3}>{T.translate('table.totalNetBanking')}</TableRowColumn>
                <TableRowColumn
                    className="alignRight">{this.getAmountString(this.state.operationList.totalNetBanking)}</TableRowColumn>
            </TableRow>
        );
    }

    renderOperationActivity(data, index){
        const activityData = OperationService.getDataActivity(data);
        return (
            <TableRowColumn style={this.getStrippedStyle(index)} className="tooltip">
                <div>
                    {activityData.text}
                </div>
                <span className="hooverText"> {activityData.hover} </span>
            </TableRowColumn>
        );
    }

    renderFRContractNumberColumn(data, index) {
        if(OPERATION_CATEGORY.PROCESSING_FEES === data.category) {
            return (
                <TableRowColumn style={this.getStrippedStyle(index)} className="tooltip tinyColumn">
                    <div className="actionButton" onClick={() => {this.props.handleInvoiceDownload(data.idInvoice)}}>
                        {data.contractNumber}
                    </div>
                    <span className="hooverText"> {data.contractNumber} </span>
                </TableRowColumn>
            )
        } else {
            /*Pour les flux Pass on affiche le code PASS dans le numéro de contrat */
            return(
                <TableRowColumn style={this.getStrippedStyle(index)} className="tooltip tinyColumn">
                    <div className="">{data.streamType === STREAM_TYPE.PASS_CARD.code ? data.shopPass : data.contractNumber}</div>
                    <span className="hooverText">{data.streamType === STREAM_TYPE.PASS_CARD.code ? data.shopPass : data.contractNumber}</span>
                </TableRowColumn>
            )
        }
    }

    /*********************************************
     * ************ Table Header *****************
     *********************************************/

    /**
     * Crée la liste des éléments qui doivent être dans le header
     */
    createHeaderItems() {
        this.headerItemList = [
            {
                type: FilterType.financingDate,
                showToolTip: true,
                text: T.translate("table.periodic.financingDateShort"),
                textLong: T.translate("table.periodic.financingDateLong")
            },
            {
                type: FilterType.contractNumber,
                isNumber: true,
                text: T.translate("table.contractNumber"),
                class: 'tinyColumn'
            },
            {
                type: FilterType.nameShop,
                isNumber: false,
                text: T.translate("table.nameShop"),
            },
            {
                type: FilterType.tradeDate,
                isNumber: true,
                showToolTip: true,
                text: T.translate("table.periodic.transactionDateShort"),
                textLong: T.translate("table.periodic.transactionDateLong")
            },
            this.getCorrectColumn(),
            {
                type: FilterType.sens,
                isNumber: false,
                text: T.translate("table.sens")
            },
            {
                type: FilterType.grossAmount,
                isNumber: true,
                alignRight: true,
                showToolTip: true,
                text: T.translate("table.periodic.grossAmountShort") + " €",
                textLong: T.translate("table.periodic.grossAmountLong") + " €"
            },
            {
                type: FilterType.COMMISSION,
                isNumber: true,
                alignRight: true,
                showToolTip: true,
                text: T.translate("table.periodic.commissionShort") + " €",
                textLong: T.translate("table.periodic.commissionLong") + " €"
            },
            {
                type: FilterType.netAmount,
                isNumber: true,
                alignRight: true,
                showToolTip: true,
                text: T.translate("table.periodic.netAmoutShort") + " €",
                textLong: T.translate("table.periodic.netAmoutLong") + " €"
            }
        ]

        if (this.props.location === 'FR') {
            this.headerItemList.splice(5, 0, this.getNbTransactionColumn());
        }
    }

    /**
     * Récupère la bonne colonne entre le coda et le n43
     */
    getCorrectColumn() {
        if (this.props.selectedStreamType === STREAM_TYPE.PASS_CARD) {
            return null;
        }
        if (this.props.location === 'BE') {
            return {
                type: FilterType.cardType,
                isNumber: false,
                showToolTip: true,
                text: T.translate("table.periodic.cardTypeShort"),
                textLong: T.translate("table.periodic.cardTypeLong")
            };
        } else if (this.props.location === 'FR') {
            return {
                type: FilterType.activity,
                isNumber: false,
                text: T.translate("table.activity")
            };
        }
        // cas par défaut : ES
        return {
            type: FilterType.operationType,
            isNumber: false,
            showToolTip: true,
            text: T.translate("table.periodic.operationTypeShort"),
            textLong: T.translate("table.periodic.operationTypeLong")
        };
    }

    getNbTransactionColumn() {
        return {
            type: FilterType.nbTransactions,
            isNumber: true,
            alignRight: true,
            text: T.translate("table.nbTransactionsLong")
        };
    }

    /**
     * Retourne les éléments présent dans le header des totaux
     */
    getTableTotalHeaderFields(displayAllField = true) {
        return (
            <TableRow key="total-header-fields" className="headerFieldRow">
                <TableRowColumn colSpan={this.getSpanColumn() - 1}/>
                <TableHeaderColumn className="alignRight">
                    {this.props.location === 'FR' ? T.translate("table.nbTransactionsLong") : null}
                </TableHeaderColumn>
                <TableRowColumn className="tinyColumn" />
                <TableHeaderColumn className="alignRight">
                    {displayAllField ? T.translate("table.periodic.grossAmountShort") + ' €' : ''}
                </TableHeaderColumn>
                <TableHeaderColumn className="alignRight">
                    {displayAllField ? T.translate("table.periodic.commissionShort") + ' €' : ''}
                </TableHeaderColumn>
                <TableHeaderColumn className="alignRight">
                    {T.translate("table.periodic.netAmoutShort")} €
                </TableHeaderColumn>
            </TableRow>
        )
    }

    /**
     * Retourne les éléments présent dans le header
     */
    getTableHeaderFields() {
        return (
            <TableRow key="header-fields" className="headerFieldRow">
                {this.headerItemList.map((item) => {
                    if (!!item) {
                        return (
                            <TableHeaderColumn key={item.type} className={item.class}>
                                <SortComponent isSelected={this.state.selectedFilter === item.type}
                                               alignRight={item.alignRight}
                                               showToolTip={item.showToolTip} action={(desc) => {
                                    if (item.type === FilterType.COMMISSION) {
                                        this.sortDataByCommision(desc)
                                    } else if (item.type === FilterType.tradeDate) {
                                        this.sortByDate(desc)
                                    } else if (item.isNumber) {
                                        this.sortNumber(item.type, desc)
                                    } else {
                                        this.sortString(item.type, desc)
                                    }
                                }} text={item.text} textLong={item.textLong}/>
                            </TableHeaderColumn>
                        )
                    }
                    return null;
                })
                })
            </TableRow>
        )
    }


    /**********************************************
     * ************ Calcul des totaux *************
     **********************************************/
    getAmountString(amount) {
        const amountNumber = Number(amount);
        return (amountNumber > 0 ? '+ ' : '') + amountNumber.toPrice();
    }


    /**********************************************
     * ************ Trie du tableau ***************
     **********************************************/

    sortNumber(category, desc) {
        const operationCopyList = this.state.operationList;
        operationCopyList.operationPeriodicList.forEach((operation) => {
            return operation.operationList.sort(function (a, b) {
                if (desc) {
                    return a[category] > b[category] ? -1 : 1;
                }
                return b[category] > a[category] ? -1 : 1;
            });
        });

        this.setState({
            selectedFilter: FilterType[category],
            operationList: operationCopyList
        });
    }

    sortByDate(desc) {
        const operationCopyList = this.state.operationList;
        operationCopyList.operationPeriodicList.forEach((operation) => {
            return operation.operationList.sort(function (a, b) {
                //On met les operations de processing fees à la fin
                if (a.category === OPERATION_CATEGORY.PROCESSING_FEES) {
                    return 1;
                }
                if (b.category === OPERATION_CATEGORY.PROCESSING_FEES) {
                    return -1;
                }
                if (a.tradeDate && b.tradeDate) {
                    let dateA = new Date().createFrenchDate(a.tradeDate)
                    let dateB = new Date().createFrenchDate(b.tradeDate)
                    if (desc) {
                        return dateA > dateB ? -1 : 1;
                    }
                    return dateB > dateA ? -1 : 1;
                }
                return 1;
            });
        });

        this.setState({
            selectedFilter: FilterType.tradeDate,
            operationList: operationCopyList
        });
    }

    sortString(category, desc) {
        const operationCopyList = this.state.operationList;
        operationCopyList.operationPeriodicList.forEach((operation) => {
            return operation.operationList.sort(function (a, b) {
                return sortAlphabetically(a[category], b[category], desc);
            });
        });

        this.setState({
            selectedFilter: FilterType[category],
            operationList: operationCopyList
        });
    }

    sortDataByCommision(desc) {
        const operationCopyList = this.state.operationList;
        operationCopyList.operationPeriodicList.forEach((operation) => {
            return operation.operationList.sort(function (a, b) {
                if (desc) {
                    return (a.grossAmount - a.netAmount) - (b.grossAmount - b.netAmount);
                }
                return (b.grossAmount - b.netAmount) - (a.grossAmount - a.netAmount);
            });
        });

        this.setState({
            selectedFilter: FilterType.COMMISSION,
            operationList: operationCopyList
        });
    }
}

export default TableStrippedPeriodic;



// WEBPACK FOOTER //
// ./src/components/tableComponent/periodic/TableStrippedPeriodic.js